import { Injectable } from '@angular/core';

import moment from 'moment-timezone';

import { CookieKey } from '@core/http-types';

import { CookieService } from './cookie';
import { getQueryParam } from './url-helpers';

@Injectable()
export class AuthHelpers {
  constructor(private cookieService: CookieService) {}

  public clearAccessTokenFromCookieBeforeExpiration(): void {
    const expiresAt = this.cookieService.get(CookieKey.AccessTokenExpiresAt);
    if (!expiresAt) return;

    if (moment().isAfter(moment.unix(<number>(<unknown>expiresAt)).subtract(6, 'days'))) {
      this.cookieService.delete(CookieKey.AccessToken);
      this.cookieService.delete(CookieKey.AccessTokenExpiresAt);
    }
  }

  public saveCompanyInCookie(value: string): void {
    this.cookieService.doSaveInCookie(CookieKey.Company, value);
  }

  public saveOrgGuidInCookie(value: string): void {
    this.cookieService.doSaveInCookie(CookieKey.OrgGuid, value);
  }
  public clearOrgGuidInCookie(): void {
    this.cookieService.delete(CookieKey.OrgGuid, null, '.recruitee.com');
    this.cookieService.delete(CookieKey.OrgGuid, null, '.s.recruitee.com');
    this.cookieService.delete(CookieKey.OrgGuid, null, `.${document.domain}`);
    this.cookieService.delete(CookieKey.OrgGuid, null, `${document.domain}`);
  }

  public clearCompanyCookies(): void {
    this.cookieService.delete(CookieKey.Company, null, '.recruitee.com');
    this.cookieService.delete(CookieKey.Company, null, '.s.recruitee.com');
    this.cookieService.delete(CookieKey.Company, null, `.${document.domain}`);
    this.cookieService.delete(CookieKey.Company, null, `${document.domain}`);
  }

  public get isSuperadmin(): boolean {
    return getQueryParam('superadmin') === 'true';
  }

  public deleteCookie(name: string): void {
    this.cookieService.delete(name);
  }
}
